import RadialChart from './RadialChart';

export default RadialChart;
